import { render, staticRenderFns } from "./M2hPrivacy.vue?vue&type=template&id=57159864&scoped=true&"
import script from "./M2hPrivacy.vue?vue&type=script&lang=js&"
export * from "./M2hPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./M2hPrivacy.vue?vue&type=style&index=0&id=57159864&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57159864",
  null
  
)

export default component.exports